import PublicLayout from '../../components/layouts/PublicLayout';
import {SingleBlogEndpoint} from '../../lib/Endpoints.jsx';
import Image from 'next/image';
import { Container} from 'reactstrap';
import DefaultBlog from '../../public/public/default.jpg'
import{useRouter} from "next/router"
import parse from 'html-react-parser';
import axios from 'axios';
import { useEffect, useState } from 'react';

// export async function getStaticPaths() {

//  return {
// 		paths: [
// 			'/blogs/id',
// 			{ params: { id: '1' } },
// 		],
// 		fallback: true,
// 	}
// }

// export const getStaticProps = async (context) =>{

// 	const id = context.params.id;
// 	const res = await fetch(SingleBlogEndpoint + id);
// 	const data = await res.json();
// 	return{
// 		props:{
// 			data,
// 		},
// 	};
// };

function Page({data}) {
	
    if(data && data.message == "Success") {
		//const blog = data.data.data;
		const blog = data.data;

		var keyword = blog && blog.attributes ? blog.attributes.keyword.split(' ').join('_') : '';
		return (
			<>
				<div className="banner_breadcrumb_section" >
					<Container fluid="xl">
					<h1 className="main-heading-lg">Blog Detail</h1>
					</Container>
					</div>
				<Container fluid="xl" id="blog">
					{/* <div id="spinner" className="spinner_req_review" style={{"display": loading ? "block" : "none"}}>
						<div className="lds-spinner">
							<div></div><div></div><div></div><div></div><div></div><div></div>
							<div></div><div></div><div></div><div></div><div></div><div></div>
						</div>
					</div> */}
					<div className="blog-detail-section padding-wrap">
						<div className="img_section reset_img" >
						<p className={"b_category "+keyword}>{blog && blog.attributes ? blog.attributes.keyword : '--'}</p>
							<Image layout='fill' src={blog && blog.attributes ? blog.attributes.cover_image : DefaultBlog} alt="blog" height="400px" width='100'/>
						</div>
						<div className="blog_content_section">
							{
								(data.length == 0) ? <h1 className="blog_name text-center">Blog Not Exist</h1> : <div>
									<h1 className="blog_name">{blog && blog.attributes ? blog.attributes.title : ''}</h1>
									<p className="published_on"><i className="fal fa-clock"></i> {blog && blog.attributes ? blog.attributes.created_at : ''}</p>
									<div className="description-text">{blog && blog.attributes ? parse(blog.attributes.description) : ''}</div>
								</div>
							}
						</div>
					</div>
				</Container>
			</>
		)
  	} else {
		return (
			<div className="banner_breadcrumb_section" >
				<Container fluid="xl">
				<h1 className="main-heading-lg">{data.message}</h1>
				</Container>
			</div>
		)
	}
}

export async function getServerSideProps(context) {
	const {slug} = context.query;
	const res = await fetch(SingleBlogEndpoint + slug);
 	const data = await res.json();
	return { props: { data: data } };
}

Page.Layout = PublicLayout;

export default Page;
